import BaseApi from '@core/api/model';

import { wait } from '@utils/async';

export class BillingGroupApi extends BaseApi {
    static resource = 'billing-groups';
    static mockItemCount = 6;
    static mockUseFilterOverrides = true;
    static mockFilterOverrideKeys = ['request_adviser_id'];

    _normaliseMockFilters(filters = {}) {
        const normalised = { ...filters };

        if (normalised.request_adviser_id) {
            normalised.adviser_id = normalised.request_adviser_id;
            delete normalised.request_adviser_id;
        }

        return normalised;
    }

    // eslint-disable-next-line no-unused-vars
    async index_mock(offset = 0, limit = 100, sort_by = null, filters = {}) {
        await wait(200);

        const normalisedFilters = this._normaliseMockFilters(filters);
        let items = this._getMocked();

        if (!items.length) {
            items = await this._generateMocked(this.constructor.mockItemCount);
        }

        if (Object.keys(normalisedFilters).length) {
            items = this._filterMocked(items, normalisedFilters);
        }

        const sliced = offset !== null && limit !== null ? items.slice(offset, offset + limit) : items;

        const response = {
            status: 'success',
            data: sliced,
            metadata: {
                total: items.length,
                limit,
                offset
            }
        };

        return this._respond(response, () => {
            this._insertModels(response.data);
        });
    }
}

export default BillingGroupApi;
